module.exports = __webpack_public_path__ + "img/1.73e9b062.jpg";